













































import { Vue, Component } from 'vue-property-decorator'
import Vuetify from 'vuetify'
import { Rule, KeyedRules } from '@/types'
import EmailApi, { SubscribeRequest } from '@/api/EmailApi'

@Component
export default class Landing extends Vue {
  // constants
  private rules: KeyedRules = {
    email: v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
  }

  // flags
  private valid: boolean = false
  private snackbar: boolean = false
  private submitting: boolean = false

  // data
  private email: string = ''
  private snackbarMessage: string = 'This is a snackbar'

  async onSubmit () {
    this.submitting = true

    const email = this.email
    const response = await EmailApi.subscribe({ email })

    this.snackbar = true
    this.snackbarMessage = response.message

    this.submitting = false
  }
}
